/** Schiebt Badges auf dem Ring auseinander, wenn ihre Sehnen sich überlappen. */
export function resolveBadgeRingAngles(
  items: { angleDeg: number; halfWidthPx: number }[],
  ringRadius: number,
): number[] {
  const n = items.length
  if (n === 0) return []
  const angles = items.map(i => ((i.angleDeg % 360) + 360) % 360)
  if (n === 1 || ringRadius <= 0) return angles

  const order = angles.map((_, i) => i).sort((a, b) => (angles[a] ?? 0) - (angles[b] ?? 0))
  const minDelta = (i: number, j: number) => {
    const needPx = (items[i]?.halfWidthPx ?? 0) + (items[j]?.halfWidthPx ?? 0) + 4
    return (needPx / ringRadius) * (180 / Math.PI)
  }

  for (let k = 1; k < n; k++) {
    const prev = order[k - 1] ?? 0
    const cur = order[k] ?? 0
    const need = minDelta(prev, cur)
    if ((angles[cur] ?? 0) - (angles[prev] ?? 0) < need) {
      angles[cur] = (angles[prev] ?? 0) + need
    }
  }

  const first = order[0] ?? 0
  const last = order[n - 1] ?? 0
  const wrapNeed = minDelta(last, first)
  const wrapGap = (angles[first] ?? 0) + 360 - (angles[last] ?? 0)
  if (wrapGap < wrapNeed) {
    angles[first] = (angles[first] ?? 0) + (wrapNeed - wrapGap)
    for (let k = 1; k < n; k++) {
      const prev = order[k - 1] ?? 0
      const cur = order[k] ?? 0
      const need = minDelta(prev, cur)
      if ((angles[cur] ?? 0) < (angles[prev] ?? 0) + need) {
        angles[cur] = (angles[prev] ?? 0) + need
      }
    }
  }

  return angles
}
